import styled from 'styled-components';

import { OpenArrowButtonStyled } from '../active-button';
import { Text } from '../texts';

const ITEM_HEIGHT = 60;

export const DropDownContainer = styled.div<any>`
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 60px;
  border-radius: ${(p) =>
    `${p.borderRadius || 10}px ${p.borderRadius || 10}px ${p.isDropdownOpen
      ? '0 0'
      : `${p.borderRadius || 10}px ${p.borderRadius || 10}px`
    }`};
  background-color: ${(p) =>
    p.disabled
      ? p.theme.color.disabled
      : p.isDropdownOpen
        ? p.theme.color.backgroundRush
        : p.backgroundColor
          ? p.theme.color[p.backgroundColor]
          : p.theme.color.background};
  padding: ${(p) =>
    `10px 0px 10px ${p.withHeader ? p.borderRadius || 15 : 30}px`};
  box-shadow: 0 0 0 1px
    ${(p) => (p.withHeader ? p.theme.color.background : 'transparent')};
  user-select: none;
  pointer-events: ${(p) => p.disabled && 'none'};

  ${Text} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SelectedContent = styled.div<any>`
  display: flex;
  height: 100%;
  align-items: center;
  ${OpenArrowButtonStyled.Container} {
    padding: 10px ${(p) => p.borderRadius || 20}px;
  }
`;

const TextsContainer = styled.div<any>`
  flex-grow: 1;
  padding-top: ${(p) => p.withHeader && '18px'};
  overflow: hidden;
`;

const DropDownMenuContainer = styled.div<any>`
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  border-bottom-left-radius: ${(p) => p.borderRadius || 10}px;
  border-bottom-right-radius: ${(p) => p.borderRadius || 10}px;
  box-shadow: 0 0 0 1px ${(p) => p.theme.color.background};
  height: ${(p) => p.height - 1}px;
  z-index: 10;
  overflow-y: hidden;
`;

export const DropDownItem = styled.div<any>`
  outline: none;
  box-sizing: border-box;
  position: relative;
  height: ${ITEM_HEIGHT}px;
  width: 100%;
  border-top: 1px solid ${(p) => p.theme.color.background};
  background-color: ${(p) => p.theme.color.backgroundRush};
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: ${(p) => p.borderRadius || '0 15px'};

  &:first-child {
    border-top: none;
    height: ${ITEM_HEIGHT - 1}px;
  }

  svg {
    width: 20px;
    fill: ${(p) => p.theme.color.turquoise};
  }

  &:hover {
    ${Text} {
      color: ${(p) => p.theme.color.turquoise};
    }
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  cursor: text;
  outline: none;
  border: none;
  background-color: ${(p) => p.theme.color.backgroundRush};
  color: ${(props) => props.theme.color.mainFont};
  font-size: 16px;
  ::placeholder {
    color: ${(props) => props.theme.color.disabled};
    font-size: 16px;
  }
`;

export const Header = styled.span<any>`
  position: absolute;
  top: ${(p) => (p.value || !Number.isNaN(p.value) ? '12px' : '22px')};
  font-size: ${(p) => (p.value || !Number.isNaN(p.value) ? '12px' : '16px')};
  color: ${(p) => (p.value ? p.theme.color.gray : p.theme.color.mainFont)};
  transition: 0.2s ease all;
  line-height: 18px;
`;

const NoResults = styled.div`
  box-sizing: border-box;
  height: 60px;
  width: 100%;
  background-color: ${(p) => p.theme.color.backgroundRush};
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: default;
`;

const Label = styled.div`
  padding: 1px 5px;
  border-radius: 5px;
  background-color: ${(p) => p.theme.color.turquoise};
  box-shadow: ${(props) => props.theme.shadow.m};
  margin-right: 10px;
`;

const CreateItem = styled(NoResults)`
  cursor: pointer;
  position: absolute;
  bottom: 0;
  border-top: 1px solid ${(p) => p.theme.color.background};
`;

const ItemsContainer = styled.div<any>`
  height: ${p => p.height}px;
`;

export const Styled = {
  DropDownMenuContainer,
  DropDownContainer,
  SelectedContent,
  TextsContainer,
  DropDownItem,
  ITEM_HEIGHT,
  SearchInput,
  Header,
  NoResults,
  Label,
  CreateItem,
  ItemsContainer,
};
